// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
(() => {
  const rot = document.querySelector('[data-chrome-paneler]');
  if (!rot) return;
  const paneler = {
    contact: rot.querySelector('[data-chrome-panel="contact"]'),
    details: rot.querySelector('[data-chrome-panel="details"]')
  };
  const toast = rot.querySelector('[data-chrome-toast]');
  const matrixTecken = '01アイウエオカキクケコｱｲｳｴｵ0123456789ABCDEF';
  const fyllMatrix = (el) => {
    if (!el || el.dataset.fylld) return;
    let text = '';
    for (let i = 0; i < 120; i++) text += matrixTecken[Math.floor(Math.random() * matrixTecken.length)] + (i % 12 === 11 ? '\n' : ' ');
    el.textContent = text + text;
    el.dataset.fylld = '1';
  };
  const stang = (namn) => {
    if (namn) {
      const p = paneler[namn];
      p?.classList.remove('is-open');
      p?.setAttribute('hidden', '');
      document.querySelectorAll(`[data-chrome-target="${namn}"]`).forEach((k) => k.setAttribute('aria-expanded', 'false'));
      return;
    }
    Object.keys(paneler).forEach((n) => stang(n));
  };
  const arOppen = (namn) => !!paneler[namn]?.classList.contains('is-open');
  const oppna = (namn, kol, { fokus = true } = {}) => {
    const panel = paneler[namn];
    if (!panel) return;
    if (arOppen(namn)) { stang(namn); return; }
    if (kol) panel.dataset.chromeColumn = kol;
    panel.removeAttribute('hidden');
    panel.classList.add('is-open');
    fyllMatrix(panel.querySelector('[data-chrome-matrix]'));
    document.querySelectorAll(`[data-chrome-target="${namn}"]`).forEach((k) => k.setAttribute('aria-expanded', 'true'));
    if (fokus) {
      const forsta = panel.querySelector('.site-chrome__pill, .site-chrome__input');
      if (forsta && typeof forsta.focus === 'function') setTimeout(() => forsta.focus(), 420);
    }
  };
  const visaToast = (text) => {
    if (!toast) return;
    toast.textContent = text;
    toast.hidden = false;
    toast.classList.add('is-visible');
    clearTimeout(visaToast.tid);
    visaToast.tid = setTimeout(() => { toast.classList.remove('is-visible'); toast.hidden = true; }, 2400);
  };
  const kopiera = async (text) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      visaToast('Copied to dashboard');
    } catch {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      visaToast('Copied to dashboard');
    }
  };
  document.addEventListener('click', (e) => {
    const knapp = e.target.closest('[data-atgard]');
    if (!knapp?.closest('.site-chrome-wrap')) return;
    const atgard = knapp.dataset.atgard;
    if (atgard === 'chrome/kontakt/vaxla') {
      e.preventDefault();
      oppna('contact', knapp.dataset.chromeColumn);
    } else if (atgard === 'chrome/detaljer/vaxla') {
      e.preventDefault();
      oppna('details', knapp.dataset.chromeColumn);
    } else if (atgard === 'chrome/kopiera') {
      e.preventDefault();
      kopiera(knapp.dataset.kopiera || '');
      knapp.classList.add('is-kopierad');
      setTimeout(() => knapp.classList.remove('is-kopierad'), 700);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') stang(); });
  document.addEventListener('click', (e) => {
    if (!Object.keys(paneler).some(arOppen)) return;
    if (e.target.closest('.site-chrome__panel') || e.target.closest('[data-chrome-target]')) return;
    stang();
  });
  const scrollUppKnapp = document.querySelector('[data-atgard="scroll/upp"]');
  const scrollUppTextMal = '.bxyzdev-cv__text, .bxyzdev-domain-row, .bxyzdev-widgets__label, .site-chrome__contact-intro, #MainContent p, #MainContent li';
  const scrollUppTröskel = () => Math.max(96, window.innerHeight * 0.12);
  const liggerScrollUppOverText = (knapp) => {
    if (!knapp) return false;
    const sparade = knapp.style.pointerEvents;
    knapp.style.pointerEvents = 'none';
    const rect = knapp.getBoundingClientRect();
    const under = document.elementFromPoint(rect.left + rect.width * 0.5, rect.top + rect.height * 0.5);
    knapp.style.pointerEvents = sparade || '';
    return !!under?.closest(scrollUppTextMal);
  };
  const uppdateraScrollUpp = (scrollY) => {
    if (!scrollUppKnapp) return;
    const scroll = typeof scrollY === 'number' ? scrollY : window.scrollY;
    if (scroll < scrollUppTröskel()) {
      scrollUppKnapp.dataset.tillstand = 'dold';
      scrollUppKnapp.hidden = true;
      return;
    }
    scrollUppKnapp.hidden = false;
    scrollUppKnapp.dataset.tillstand = liggerScrollUppOverText(scrollUppKnapp) ? 'over-text' : 'aktiv';
  };
  if (scrollUppKnapp) {
    document.addEventListener('bxyz:scroll', (e) => uppdateraScrollUpp(e.detail?.scroll));
    window.addEventListener('scroll', () => uppdateraScrollUpp(), { passive: true });
    window.addEventListener('resize', () => uppdateraScrollUpp(), { passive: true });
    uppdateraScrollUpp();
  }
  document.addEventListener('bxyz:scrollto', (e) => {
    if (document.documentElement.dataset.scroll === 'locomotive') return;
    const mal = e.detail?.target;
    if (mal !== 0 && mal !== '0') return;
    const start = window.scrollY;
    if (start <= 0) return;
    const bas = 720;
    const duration = Math.min(bas * 3.2, bas * (0.9 + (start / Math.max(window.innerHeight, 1)) * 0.75));
    const startTid = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 4);
    const tick = (nu) => {
      const t = Math.min(1, (nu - startTid) / duration);
      window.scrollTo(0, Math.round(start * (1 - ease(t))));
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });
  document.addEventListener('click', (e) => {
    const knapp = e.target.closest('[data-atgard="scroll/upp"]');
    if (!knapp) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('bxyz:scrollto', { detail: { target: 0, offset: 0 } }));
  });
  const init = () => {
    oppna('contact', 'a', { fokus: false });
    oppna('details', 'f', { fokus: false });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
